import React from 'react';
import { Helmet } from 'react-helmet-async';
import Button from 'components/controls/Button/Button';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => {
	return (
		<div className="not-found-page">
			<Helmet>
				<title>Page Not Found | The G.O.A.T. Grazers</title>
				<meta name="description" content="Looks like our goats wandered off and ate this page!" />
			</Helmet>
			<div className="container not-found-page__content">
				<div className="not-found-page__text">
					<h1 className="not-found-page__title">404</h1>
					<h2 className="not-found-page__subtitle">Looks like our goats wandered off...</h2>
					<p className="not-found-page__desc">
						We can't seem to find the page you're looking for. It's possible the herd already cleared it out!
					</p>
					<Button to="/" variant="primary" size="lg">
						Return to Pasture (Home)
					</Button>
				</div>
			</div>
		</div>
	);
};

export default NotFoundPage;
